// This is generated.  Alter it in blockGroups/formElements/types/Integer.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { id, title, propertyName, min, max, required, defaultValue } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // reuse consistent flags
    const { isOptional, schemaOptions } = moduleRegistration.resolveFieldFlags(
      required,
      context,
    );
    const maybeOptional = (schema) =>
      isOptional ? Type.Optional(schema) : schema;

    // Build the integer schema with constraints
    const integerOptions = {
      title: title,
      'x-id': id,
      'x-dataType': 'integer',
      'x-propertyName': propertyName,
      ...schemaOptions,
    };

    // Add min/max constraints if provided
    if (min !== undefined && min !== null) {
      integerOptions.minimum = min;
    }
    if (max !== undefined && max !== null) {
      integerOptions.maximum = max;
    }
    if (defaultValue !== undefined && defaultValue !== null) {
      integerOptions.default = defaultValue;
    }

    const integerSchema = maybeOptional(Type.Integer(integerOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: integerSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType('formElements', 'Integer', module.exports);
